import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea8633ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nofilter-message ion-padding" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "No connection to novoGloW", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Check if you have internet connection")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Get support")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_icon, {
      class: "column-item",
      icon: _ctx.errorLinkBroken
    }, null, 8, ["icon"]),
    _hoisted_2,
    _createVNode(_component_ion_label, { class: "column-item" }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_ion_button, {
      class: "column-item",
      "router-link": "/support",
      "router-direction": "forward"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}